import { useStaffAuthContext } from "./useStaffAuthContext";
import { Link,useNavigate } from "react-router-dom";

export const useStaffLogout = () => {

    const { dispatch } = useStaffAuthContext();
    const navigate = useNavigate();

    
    const logout = () => {
     //remove user from local storage
     localStorage.removeItem('staff');
     //dispatch logout action
     dispatch({type: 'STAFF_LOGOUT'});
     navigate('/administrator/login');
     
    }
    return { logout };
}